import { render } from "./HomeView.vue?vue&type=template&id=915d0214"
const script = {}

import exportComponent from "C:\\Users\\Admin\\Desktop\\dev\\dma-scot-stakeholders\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__